import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { formatDate } from "../../utils/datetime";
import { withTranslation } from "react-i18next";
import {
  libraryMyItemsMyCourses,
  learnLearningPathListView
} from "../../routes/LearningCenterRoutes";

class FailedCourseTooltipContent extends React.Component {
  retakeCourse() {
    const { isSelfAssigned } = this.props;

    if (isSelfAssigned) {
      window.location = libraryMyItemsMyCourses;
    } else window.location = learnLearningPathListView;
  }

  render() {
    const {
      passingScore,
      classes,
      passedCompletionDate,
      isActive,
      isIlt,
      t
    } = this.props;

    return (
      <span>
        <Typography variant="subtitle2" color="error">
          {t("components.failedCourseTooltipContent.failed")}
        </Typography>
        {!!passingScore && (
          <Typography variant="caption" color="textSecondary">
            {t("components.failedCourseTooltipContent.passingScore", {
              passingScore: passingScore
            })}
          </Typography>
        )}
        <Box>
          {!passedCompletionDate && !(isIlt && isActive) && (
            <Button color="primary" className={classes.button}>
              <Typography variant="button" onClick={() => this.retakeCourse()}>
                {t("components.failedCourseTooltipContent.retakeBtn")}
              </Typography>
            </Button>
          )}
          {passedCompletionDate && (
            <Typography variant="caption" color="textSecondary">
              {t("components.failedCourseTooltipContent.passedCompletionDate", {
                passedCompletionDate: formatDate(passedCompletionDate)
              })}
            </Typography>
          )}
        </Box>
      </span>
    );
  }
}

const TranslatedFailedCourseTooltipContent = withTranslation()(
  FailedCourseTooltipContent
);

export default TranslatedFailedCourseTooltipContent;
